(function(){
  if(window.__lmpHeaderPanelsReady) return;
  window.__lmpHeaderPanelsReady = true;

  var FAV_KEY = 'lmpFavorites';
  function esc(value){return String(value || '').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c];});}
  function money(cents){
    if(typeof cents !== 'number') return '';
    try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format(cents/100);}catch(e){return (cents/100).toFixed(2).replace('.',',')+' EUR';}
  }
  function rootUrl(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';}
  function getFavs(){try{return JSON.parse(localStorage.getItem(FAV_KEY)||'[]');}catch(e){return [];}}
  function closePanels(except){
    document.querySelectorAll('[data-lmp-header-panel]').forEach(function(panel){
      if(panel !== except){panel.hidden = true; panel.classList.remove('is-open');}
    });
    document.querySelectorAll('[data-lmp-header-panel-open]').forEach(function(btn){
      var target = btn.getAttribute('aria-controls');
      if(!except || target !== except.id) btn.setAttribute('aria-expanded','false');
    });
  }
  function closeSearchPanels(){
    document.querySelectorAll('[data-lmp-header-search]').forEach(function(panel){panel.hidden = true; panel.classList.remove('is-open');});
    document.querySelectorAll('[data-lmp-header-search-open]').forEach(function(btn){btn.setAttribute('aria-expanded','false');});
  }
  function openPanel(panel, opener){
    if(!panel) return;
    var willOpen = panel.hidden;
    closeSearchPanels();
    closePanels(panel);
    panel.hidden = !willOpen;
    panel.classList.toggle('is-open', willOpen);
    if(opener) opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if(willOpen){
      if(panel.matches('[data-lmp-favorites-panel]')) renderFavorites(panel);
      if(panel.matches('[data-lmp-cart-panel]')) renderCart(panel);
    }
  }
  function renderFavorites(panel){
    var list = panel.querySelector('[data-lmp-panel-favorites-list]');
    var count = panel.querySelector('[data-lmp-panel-favorites-count]');
    var favs = getFavs();
    if(count) count.textContent = favs.length === 1 ? '1 Produkt gemerkt' : favs.length + ' Produkte gemerkt';
    if(!list) return;
    if(!favs.length){
      list.innerHTML = '<div class="lmp-mini-panel-empty"><strong>Noch nichts gemerkt.</strong><span>Tippen Sie auf ein Herz bei einem Produkt. Die Auswahl erscheint dann hier.</span></div>';
      return;
    }
    list.innerHTML = favs.slice(0,4).map(function(item){
      var url = item.url || ('/products/' + encodeURIComponent(item.handle || ''));
      return '<a class="lmp-mini-panel-item" href="'+esc(url)+'"><span class="lmp-mini-panel-thumb">♡</span><span><strong>'+esc(item.title || item.handle || 'Produkt')+'</strong><em>Favorit ansehen</em></span></a>';
    }).join('');
  }
  function renderCart(panel){
    var list = panel.querySelector('[data-lmp-panel-cart-list]');
    var count = panel.querySelector('[data-lmp-panel-cart-count]');
    var total = panel.querySelector('[data-lmp-panel-cart-total]');
    if(list) list.innerHTML = '<div class="lmp-mini-panel-empty"><span>Warenkorb wird geladen...</span></div>';
    fetch(rootUrl() + 'cart.js', {headers:{Accept:'application/json'}}).then(function(r){if(!r.ok) throw new Error('cart'); return r.json();}).then(function(cart){
      if(count) count.textContent = cart.item_count === 1 ? '1 Artikel im Warenkorb' : cart.item_count + ' Artikel im Warenkorb';
      if(total){ total.hidden = false; total.innerHTML = '<span>Gesamtbetrag</span><strong>'+money(cart.total_price)+'</strong>'; }
      if(!list) return;
      if(!cart.items || !cart.items.length){
        list.innerHTML = '<div class="lmp-mini-panel-empty"><strong>Der Warenkorb ist leer.</strong><span>Produkte entdecken und direkt hier den Überblick behalten.</span></div>';
        if(total){ total.hidden = true; total.innerHTML = ''; }
        return;
      }
      list.innerHTML = cart.items.slice(0,3).map(function(item){
        var img = item.image ? '<img src="'+esc(item.image)+'" alt="'+esc(item.product_title)+'" loading="lazy">' : '🛒';
        return '<a class="lmp-mini-panel-item" href="'+esc(item.url || '/cart')+'"><span class="lmp-mini-panel-thumb">'+img+'</span><span><strong>'+esc(item.product_title || item.title)+'</strong><em>'+esc(item.quantity)+' × '+money(item.final_price)+'</em></span></a>';
      }).join('');
    }).catch(function(){
      if(list) list.innerHTML = '<div class="lmp-mini-panel-empty"><strong>Warenkorb konnte nicht geladen werden.</strong><span>Öffnen Sie den Warenkorb direkt über den Button.</span></div>';
    });
  }
  document.addEventListener('click', function(event){
    var opener = event.target.closest('[data-lmp-header-panel-open]');
    if(opener){
      event.preventDefault();
      var id = opener.getAttribute('aria-controls');
      var panel = id ? document.getElementById(id) : null;
      openPanel(panel, opener);
      return;
    }
    if(event.target.closest('[data-lmp-header-panel-close]')){
      closePanels();
      return;
    }
    if(!event.target.closest('[data-lmp-header-panel], [data-lmp-header-panel-open], [data-lmp-header-search], [data-lmp-header-search-open]')) closePanels();
  });
  document.addEventListener('keydown', function(event){if(event.key === 'Escape') closePanels();});
  document.addEventListener('lmp:favorites:changed', function(){document.querySelectorAll('[data-lmp-favorites-panel].is-open').forEach(renderFavorites);});
  document.addEventListener('lmp:cart:add', function(){document.querySelectorAll('[data-lmp-cart-panel].is-open').forEach(renderCart);});
  document.addEventListener('lmp:cart:update', function(){document.querySelectorAll('[data-lmp-cart-panel].is-open').forEach(renderCart);});
})();
